var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.738 0.358464L26.6805 7.70419C27.1065 8.15496 27.1065 8.88581 26.6805 9.33658L19.738 16.6823C19.312 17.1331 18.6212 17.1331 18.1952 16.6823C17.7692 16.2315 17.7692 15.5007 18.1952 15.0499L23.2754 9.67466H0V7.36612H23.2754L18.1952 1.99085C17.7692 1.54008 17.7692 0.809234 18.1952 0.358464C18.6212 -0.0923069 19.312 -0.0923069 19.738 0.358464Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowblack);
export default __webpack_public_path__ + "static/media/Arrowblack.0518323b195d99bd3b6dffb2c6ee64f2.svg";
export { ForwardRef as ReactComponent };